<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="Array.isArray(collection) ? collection : collection.toArray()"
      :options="options"
      :theme="theme"
      id="resultexport-table"
      class="w-100"
      @row-click="onRowClick"
    >
      <span slot="code" slot-scope="{ row }">
        <a :href="'#/result-exports/' + row.id" class="btn-link">{{
          row.code
        }}</a>
      </span>

      <span slot="status" slot-scope="{ row }">
        <result-export-status-badge :result_export="row" />
      </span>

      <span slot="user" slot-scope="{ row }">
        {{ row.user.name }}
      </span>

      <span slot="process" slot-scope="{ row }">
        {{ row.schedulable_process.name }}
      </span>

      <span class="task-csv" slot="tasks" slot-scope="{ row }">
        <b-badge
          pill
          variant="light"
          class="mr-1 fs-6"
          v-for="(task, index) in row.tasks"
          :key="index"
          >{{ task.name }}</b-badge
        >
      </span>

      <span slot="created_at" slot-scope="{ row }">
        <span v-if="isListPage">
          {{ row.created_at | moment('D MMM YYYY, h:mm a') }}
        </span>
        <span v-else>
          {{ row.created_at | moment("h:mm a")  }}
        </span>
      </span>

      <span slot="imports" slot-scope="{ row }">
        {{ row.result_imports.length }}
      </span>

      <span slot="actions" slot-scope="{ row }" v-if="!isListPage">
        <result-export-download-button
          v-if="isDownloadable(row)"
          :result_export="row"
        />

        <result-export-import-button
          v-if="isDownloadable(row)"
          :result_export="row"
        />
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import ResultExportStatusBadge from "@/components/lab/resultexport/ResultExportStatusBadge";
import ResultExportImportButton from "@/components/lab/resultexport/ResultExportImportButton";
import ResultExportDownloadButton from "@/components/lab/resultexport/ResultExportDownloadButton";
import { ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "ResultExportTable",
  components: {
    ClientTable,
    Event,
    ResultExportStatusBadge,
    ResultExportImportButton,
    ResultExportDownloadButton,
  },
  props: {
    collection: {},
    isListPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      columns: [
        "code",
        "status",
        "created_at",
        "user",
        "process",
        "tasks",
        "imports",
        "actions",
      ],
      options: {
        headings: {
          name: "Result Export Name",
          description: "Description",
        },
        sortable: ["status"],
        filterable: false,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      refresh: {
        tries: 1,
        interval: 500,
        timeout: null,
      },
    };
  },
  mounted() {
    if (this.isListPage) {
      // remove the 'actions' tab
      this.columns.pop()
    }
  },
  computed: {},
  methods: {
    onRowClick(event) {
      this.$emit('rowClick', event.row);
    },
    isDownloadable(row) {
      return row && row.status === "Complete";
    },
    /**
     * Check collection for incomplete status items that will
     * require the list to be reloaded.
     */
    checkIncomplete() {
      try {
        this.collection.each((result_export) => {
          if (
            result_export.status !== "Complete" &&
            result_export.status !== "Error"
          ) {
            return this.triggerReload();
          }
        });
      } catch (err) {
        this.collection.forEach((result_export) => {
          if (
            result_export.status !== "Complete" &&
            result_export.status !== "Error"
          ) {
            return this.triggerReload();
          }
        });
      }
    },
    /**
     * Emit a data refresh request event on a debounce.
     */
    triggerReload() {
      // clear existing timeout
      clearTimeout(this.refresh.timeout);

      // define timeout interval
      let interval = this.refresh.interval * this.refresh.tries;

      // create new timeout
      this.refresh.timeout = setTimeout(() => {
        this.$emit("dataRefreshRequest");
        this.refresh.tries += 1;
      }, interval);
    },
  },
  watch: {
    collection: {
      handler() {
        this.checkIncomplete();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

